import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="student-activity-log-export"
export default class extends Controller {
  static targets = ["modal", "item", "selectAll", "studentCount"];

  // When "select all" is clicked
  toggleAll(event) {
    const checked = event.target.checked;
    this.itemTargets.forEach((cb) => (cb.checked = checked));
  }

  // When any individual checkbox is clicked
  updateSelectAll() {
    const allChecked =
      this.itemTargets.length > 0 && this.itemTargets.every((cb) => cb.checked);
    this.selectAllTarget.checked = allChecked;
  }

  submitStudentActivityLogExportButton(event) {
    event.preventDefault();

    const user_ids = this.itemTargets
      .filter((cb) => cb.checked)
      .map((cb) => cb.value);

    const baseUrl = event.currentTarget.getAttribute("href");
    const url = new URL(baseUrl, window.location.origin);

    let csrfToken = null;
    const csrfMeta = document.querySelector("meta[name='csrf-token']");
    if (csrfMeta) {
      csrfToken = csrfMeta.getAttribute("content");
    }

    fetch(url.toString(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(csrfToken && { "X-CSRF-Token": csrfToken }),
      },
      body: JSON.stringify({ user_ids: user_ids }),
    })
      .then((response) => {
        if (response.ok) {
          this.close();
          this.uncheckAll();
          alert("Export process has started. Please wait for few minutes.");
        } else {
          alert("Export failed.");
        }
      })
      .catch(() => {
        alert("Network error: Export could not be started.");
      });
  }

  updateStudentCount(event) {
    const count = this.itemTargets.filter((cb) => cb.checked).length;
    this.studentCountTarget.textContent = count;
    if (count === 0) {
      alert("Please select at least one record to export.");
      return;
    } else {
      this.open(event);
    }
  }

  open(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    this.modalTarget.classList.remove("hidden");
    this.modalTarget.classList.add("show");

    // Ensure that the next tick focuses the first focusable element
    setTimeout(() => {
      this.setFocusOnFirstElement();
    }, 0);
  }

  setFocusOnFirstElement() {
    const focusableElements = this.modalTarget.querySelectorAll(
      'input[type="checkbox"], button, [tabindex]:not([tabindex="-1"])'
    );
    if (focusableElements.length > 0) {
      focusableElements[0].focus();
    }
  }

  close() {
    if (this.modalTarget) {
      const subscriberForm = document.querySelector("#subscriber-form");
      if (subscriberForm) {
        subscriberForm.reset();
      }

      this.modalTarget.classList.add("hidden");
      this.modalTarget.classList.remove("show");
    }
  }

  uncheckAll() {
    this.itemTargets.forEach((cb) => (cb.checked = false));
    this.selectAllTarget.checked = false;
  }
}
